import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Select from './Select';

import { close, listupdater, loadingflas, open } from '../redux/popupSlice';

import MeettingWriter from './MeettingWriter';
import AutocutomerSet from './AutocutomerSet';
import CustomerWrite from './CustomerWrite';


import * as APIS from "../utils/service";
import consts from '../libs/consts';
import { getMemberinfo, hpHypen, numFormat } from '../utils/utils';
import { useGoogleLogin } from '@react-oauth/google';

export default function PopCustomLeftDetail(props) {

    const {
        row : parentRow,
        setcustomerdetailflag=() => {},
        customerIdx=0,
        setproductIdx=() => {},
        setproductdetailflag=() => {},
        confirmdateupdate = false,
        updatemain=()=>{}
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const yoil = ['일', '월', '화', '수', '목', '금', '토'];

    const [memberinfos, setmemberinfos] = useState(''); 

    const [meettingwriterpop, setmeettingwriterpop] = useState(false);   
    const [autocustomerpop, setautocustomerpop] = useState(false);   
    const [detailwrite, setdetailwrite] = useState(false); 
    const [updatestatus, setupdatestatus] = useState(false); 

    const [customsendlist, setcustomsendlist] = useState([]); 
    const [mettingsArr, setmettingsArr] = useState([]);

    const [desc, setdesc] = useState(''); //특이사항

    const loadMemberInfo = () =>{
        return new Promise((resolve)=>{
            APIS.postData('/v1/auth/info').then(({ data }) => {
                resolve(data);
            }).catch((e) => {
                resolve('')
            });
        })
    }
    useEffect(() => {
        // getMemberinfo(setmemberinfos);
    }, []);

    //console.log(memberinfos);
    const { configdata } = useSelector(s => s.configReducer);
    let statusArrs = [];
    let customerpositionArr = configdata?.consts?.customerPositionOpenConsts;
    configdata?.consts?.customerStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 99){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    
    let customerlabels = customerpositionArr?.map((x, i) => {
        return {labels: x?.title, values: x?.idx}
    })

    //console.log(category_1_setting);
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })


    const [row, setrow] = useState({}); 

    // const [priceinfos, setpriceinfos] = useState([
    //     {viewernames: '보증금', values: '5,000만원'},
    //     {viewernames: '월세', values: '200만원'},
    //     {viewernames: '권리금', values: '5,000만원'},
    //     {viewernames: '실투자금', values: '10,000만원'},
    //     {viewernames: '층수', values: '1층'},
    //     {viewernames: '전용면적', values: '23평~25평'},
    //     {viewernames: '연식', values: '2020년 이후'},
    //     {viewernames: '입주시기', values: '2024년 1월 22일'},
    // ]);
    const [priceinfos, setpriceinfos] = useState([]);   

    const [mobileactive, setmobileactive] = useState(0);

    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);
        

    useEffect(() => {
        rowDataSubmit();
        customSendProc();
    }, [customerIdx, updatestatus]);
    const customSendProc = () => {
        let sender = { idx: customerIdx }
        //let sender = { idx: 10493 }
        APIS.postData('/v1/customer/getItems', sender).then(({ data }) => {
            if (data) {
                setcustomsendlist(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
        });
    }
    const rowDataSubmit = async () => {
        let memberInfo = await loadMemberInfo();
        setmemberinfos(memberInfo);

        if(memberInfo?.idx*1 == parentRow?.user?.idx*1){
            console.log("!!! 내 고객")
            dispatch(loadingflas({ loading: true }));
            let sender = { idx: customerIdx }
            APIS.postData('/v1/customer/get', sender).then(({ data }) => {
                if(data){
                    const { customer, compony_arr, my_arr, other_arr, meetings } = data;
                    setrow(customer);
                    setmettingsArr(customer?.meetings);
                    setpriceinfos([
                        {viewernames: customer?.sell_type === '매매' ? '매매가' : '보증금', values: `${numFormat(customer?.price_all_min)}만원 ~ ${numFormat(customer?.price_all_max)}만원`},
                        {viewernames: '월세', values: `${numFormat(customer?.price_month_min)}만원 ~ ${numFormat(customer?.price_month_max)}만원`},
                        {viewernames: '권리금', values: `${numFormat(customer?.price_key_min)}만원 ~ ${numFormat(customer?.price_key_min)}만원`},
                        {viewernames: '실투자금', values: `${numFormat(customer?.price_real)}만원`},
                        {viewernames: '희망 층수', values: `${numFormat(customer?.item_floor_min)}층 ~ ${numFormat(customer?.item_floor_max)}층`},
                        {viewernames: '희망 면적', values: `${numFormat(customer?.item_area_min)}㎡ ~ ${numFormat(customer?.item_area_max)}㎡`},
                        {viewernames: '희망 연식', values: `${customer?.item_year_min}년 ~ ${customer?.item_year_max}년`},
                        {viewernames: '입주시기', values: `${customer?.in_year} ${customer?.in_year_option1 ? '협의가능' : ''}  ${customer?.in_year_option2 ? '상관없음' : ''}`},
                    ]);  
                    
                    setdesc(customer?.memo);
                    setupdatestatus(false);
                }
            }).catch(({ response }) => {
                const { data } = response;
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });
        } else {
            console.log("!!! 공동중개 고객", parentRow);
            setpriceinfos([
                {viewernames: parentRow?.sell_type === '매매' ? '매매가' : '보증금', values: `${numFormat(parentRow?.price_all_min)}만원 ~ ${numFormat(parentRow?.price_all_max)}만원`},
                {viewernames: '월세', values: `${numFormat(parentRow?.price_month_min)}만원 ~ ${numFormat(parentRow?.price_month_max)}만원`},
                {viewernames: '권리금', values: `${numFormat(parentRow?.price_key_min)}만원 ~ ${numFormat(parentRow?.price_key_min)}만원`},
                {viewernames: '실투자금', values: `${numFormat(parentRow?.price_real)}만원`},
                {viewernames: '희망 층수', values: `${numFormat(parentRow?.item_floor_min)}층 ~ ${numFormat(parentRow?.item_floor_max)}층`},
                {viewernames: '희망 면적', values: `${numFormat(parentRow?.item_area_min)}㎡ ~ ${numFormat(parentRow?.item_area_max)}㎡`},
                {viewernames: '희망 연식', values: `${parentRow?.item_year_min}년 ~ ${parentRow?.item_year_max}년`},
                {viewernames: '입주시기', values: `${parentRow?.in_year} ${parentRow?.in_year_option1 ? '협의가능' : ''}  ${parentRow?.in_year_option2 ? '상관없음' : ''}`},
            ]);  
        }
    }

    return (
        <>
           
            <div className='ProductDetailArea' style={{ zIndex: 1003 }}>
                <div>
                    <div className='ProductDetailAreaBG' 
                        //onClick={() => setcustomerdetailflag(false)}
                    />

                    <div></div>
                    <div className="ProductDetailpop" style={{ width: 360}}> 
                        <div className="ProductpopTitle padding20 pcviewflex">
                            <span>고객 상세 </span>
                            <button
                                onClick={() => {
                                    setcustomerdetailflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />                                            
                            </button>
                        </div>
                        <div className="ProductpopTitle mobileViewer2" style={{ paddingRight: 20 }}>
                            <div>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                >
                                    <buttom
                                        onClick={() => {
                                            setmobileactive(0);
                                        }}
                                        className={`mobilepopbuttons ${mobileactive === 0 && 'active'}`}
                                    >
                                        고객상세
                                    </buttom>
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    setproductdetailflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />                                            
                            </button>
                        </div>                        

                        <div className="ProductpopContents">
                            <div className={`ProductpopContentsLeft ${mobileactive === 0 && 'active'}`} style={{ width: '100%' }}>
                                <div className='productinfoArea1 padding20'>
                                    <div className="productnumberinfos">
                                        <div className='linedotTxt'>
                                            {(memberinfos && memberinfos?.idx === row?.u_idx) ? 
                                            <>
                                                <span>고객번호 : {row?.idx}</span>
                                                <span></span>
                                                <span>등록: {moment(row?.create_dt).format('YY.MM.DD')}</span>
                                            </>:
                                            <>
                                                <span>고객번호 : {parentRow?.idx}</span>
                                                <span></span>
                                                <span>등록: {moment(parentRow?.create_dt).format('YY.MM.DD')}</span>
                                            </>}
                                            
                                        </div>
                                        <div>
                                            {(memberinfos && memberinfos?.idx === row?.u_idx) ? 
                                            <>
                                                <div className={`setstyles ${statusArrs?.find(item => item?.idx*1 === row?.status*1)?.arrays[1]}`}>
                                                    {statusArrs?.find(item => item?.idx*1 === row?.status*1)?.title}
                                                </div>
                                            </>:
                                            <>
                                                <div className={`setstyles ${statusArrs?.find(item => item?.idx*1 === parentRow?.status*1)?.arrays[1]}`}>
                                                    {statusArrs?.find(item => item?.idx*1 === parentRow?.status*1)?.title}
                                                </div>
                                            </>}
                                        </div>
                                    </div>
                                    <div className="productinfos1" >
                                        <div className='linedotTxt'>
                                            {(memberinfos && memberinfos?.idx === row?.u_idx) ? 
                                            <>
                                                <span>{category_2_setting?.find(item => item?.values*1 === row?.category_2*1)?.names}</span>
                                                <span></span>
                                                <span>{row?.sell_type}</span>
                                            </>:
                                            <>
                                                <span>{category_2_setting?.find(item => item?.values*1 === parentRow?.category_2*1)?.names}</span>
                                                <span></span>
                                                <span>{parentRow?.sell_type}</span>
                                            </>}
                                        </div>
                                    </div>
                                    <div className="productinfos1 styles2" >{row?.title}</div>
                                    {(memberinfos && memberinfos?.idx === row?.u_idx) ? 
                                    <>
                                        {row?.sell_type === '월세' ?
                                        <div className="productinfos1 styles1 bolds" >월세 {numFormat(row?.price_all_min)}~{numFormat(row?.price_all_max)}/{numFormat(row?.price_month_min)}~{numFormat(row?.price_month_max)}</div>
                                        :
                                        <div className="productinfos1 styles1 bolds" >{numFormat(row?.price_all_min)}만원 ~ {numFormat(row?.price_all_max)}만원</div>
                                        }
                                    </>:
                                    <>
                                        {parentRow?.sell_type === '월세' ?
                                        <div className="productinfos1 styles1 bolds" >월세 {numFormat(parentRow?.price_all_min)}~{numFormat(parentRow?.price_all_max)}/{numFormat(parentRow?.price_month_min)}~{numFormat(parentRow?.price_month_max)}</div>
                                        :
                                        <div className="productinfos1 styles1 bolds" >{numFormat(parentRow?.price_all_min)}만원 ~ {numFormat(parentRow?.price_all_max)}만원</div>
                                        }
                                    </>}
                                    <div className="productinfos1 styles3" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z" fill="#999999"/>
                                        </svg>      
                                        {(memberinfos && memberinfos?.idx === row?.u_idx) ?
                                        <>
                                            {row?.citys?.filter(item => item?.polygon === null)?.map(item => item.dong === '전체' ? item.sigungu+" 전체" : item.dong)?.join(", ")}
                                            {row?.citys?.filter(item => item?.polygon !== null)?.map((item, index) => (index === 0 && row?.citys?.filter(item => item?.polygon === null)?.length > 0) ? ", 폴리곤"+(index+1) : "폴리곤"+(index+1) )?.join(", ")}
                                        </>:
                                        <>
                                            {parentRow?.citys?.filter(item => item?.polygon === null)?.map(item => item.dong === '전체' ? item.sigungu+" 전체" : item.dong)?.join(", ")}
                                            {parentRow?.citys?.filter(item => item?.polygon !== null)?.map((item, index) => (index === 0 && parentRow?.citys?.filter(item => item?.polygon === null)?.length > 0) ? ", 폴리곤"+(index+1) : "폴리곤"+(index+1) )?.join(", ")}
                                        </>}
                                    </div>
                                    {(memberinfos && memberinfos?.idx === row?.u_idx) ?
                                    <>
                                        <div className="productinfos1 styles4" >의뢰인: {row?.hp && hpHypen(row?.hp)}</div>
                                        <div className="productinfos1 styles5" >담당자:<b>{row?.user?.name} {row?.user?.rank}</b></div>
                                    </>:
                                    <>
                                        <div className="productinfos1 styles5" >담당자:<b>{parentRow?.user?.name} {parentRow?.user?.rank}</b></div>
                                    </>}
                                    
                                    {(memberinfos && memberinfos?.idx === row?.u_idx) &&
                                    <>
                                    {/* <div style={{ marginTop: 20, fontWeight: 700, textAlign: 'center'}}>
                                    의뢰인에게 확인 하셨나요? 
                                    </div>
                                    <div className='margint10'>
                                        <Button
                                            buttonTxt={'아직 매물을 구하는 중으로 확인됩니다.'}
                                            styles={{
                                                backgroundColor: '#656565'
                                            }}
                                            onPress={() => { 
                                                let sender = {
                                                    idx: customerIdx,
                                                    memo: desc,
                                                }
                                                dispatch(loadingflas({ loading: true }));
                                                APIS.postData('/v1/customer/memoUpdate', sender).then(({ data }) => {
                                                    if(data){
                                                        //console.log(data);
                                                        dispatch(
                                                            open({
                                                                component: `확인일이 갱신되었습니다.`,
                                                                title: '알림',
                                                                titleviewer: true,
                                                                alert: false,
                                                                button: "확인",
                                                                onPress: () => {
                                                                    updatemain();
                                                                    dispatch(close());
                                                                }
                                                            })
                                                        );   
                                                    }
                                                }).catch(({ response }) => {
                                                    const { data } = response;
                                                    console.log(response);
                                                }).finally(() => {
                                                    dispatch(loadingflas({ loading: false }));
                                                });      
                                            }}
                                        />                                    
                                    </div>
                                    <div className='margint10'>
                                        <Button
                                            buttonTxt={'잠시 거래를 보류하겠다고 합니다.'}
                                            styles={{
                                                backgroundColor: '#5C96ED'
                                            }}
                                            onPress={() => { 
                                                let sender = {
                                                    idx: row?.idx,
                                                    status: 3,
                                                }
                                                dispatch(loadingflas({ loading: true }));
                                                APIS.postData('/v1/customer/statusUpdate', sender).then(({ data }) => {
                                                    if(data){

                                                        dispatch(close());
                                                        dispatch(
                                                            open({
                                                                component: `보류로 변경되었습니다.`,
                                                                title: '알림',
                                                                titleviewer: true,
                                                                alert: false,
                                                                button: "확인",
                                                                onPress: () => {
                                                                    rowDataSubmit();
                                                                    updatemain();
                                                                    dispatch(close());
                                                                }
                                                            })
                                                        );   

                                                    }
                                                }).catch(({ response }) => {
                                                    const { data } = response;
                                                    console.log(response);
                                                }).finally(() => {
                                                    dispatch(loadingflas({ loading: false }));
                                                });  
                                            }}
                                        />                                    
                                    </div>
                                    <div className='margint10'>
                                        <Button
                                            buttonTxt={'거래가 완료되었다고 합니다.'}
                                            styles={{
                                                backgroundColor: '#FF6F6F'
                                            }}
                                            onPress={() => { 
                                                let sender = {
                                                    idx: row?.idx,
                                                    status: 99,
                                                }
                                                dispatch(loadingflas({ loading: true }));
                                                APIS.postData('/v1/customer/statusUpdate', sender).then(({ data }) => {
                                                    if(data){

                                                        dispatch(close());
                                                        dispatch(
                                                            open({
                                                                component: `거래완료로 변경되었습니다.`,
                                                                title: '알림',
                                                                titleviewer: true,
                                                                alert: false,
                                                                button: "확인",
                                                                onPress: () => {
                                                                    rowDataSubmit();
                                                                    updatemain();
                                                                    dispatch(close());
                                                                }
                                                            })
                                                        );   

                                                    }
                                                }).catch(({ response }) => {
                                                    const { data } = response;
                                                    console.log(response);
                                                }).finally(() => {
                                                    dispatch(loadingflas({ loading: false }));
                                                });    
                                            }}
                                        />                                    
                                    </div> */}
                                    
                                    </>
                                    }
                                </div>
                                
                                <div className='productinfoArea2 padding20'>
                                    <div>
                                        <div className="title_txt bolds">희망 조건</div>
                                        <div className='infos'>
                                            {priceinfos?.length > 0 && priceinfos?.map((x, i) => {
                                                return (
                                                    <div key={i}>
                                                        <div>{x?.viewernames}</div>
                                                        <div>{x?.values}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    
                                    {(memberinfos && memberinfos?.idx === row?.u_idx) &&
                                    <div>
                                        <div className="title_txt bolds">특이사항</div>
                                        <div className='textareasinput'>
                                            <textarea 
                                                value={desc}                                                
                                                onChange={(e) => {
                                                    setdesc(e.target.value);
                                                }}
                                            />
                                        </div>
                                        <div className='buttons'>
                                            <Button 
                                                buttonTxt={'저장'} 
                                                styles={{
                                                    width: 49, height: 33, borderRadius: 4, border: '1px solid #333',
                                                    fontWeight: 700, backgroundColor: '#fff', color: '#000', fontSize: 14
                                                }}
                                                onPress={() => {
                                                    console.log('saved!');
                                                    let sender = {
                                                        idx: customerIdx,
                                                        memo: desc,
                                                    }
                                                    dispatch(loadingflas({ loading: true }));
                                                    APIS.postData('/v1/customer/memoUpdate', sender).then(({ data }) => {
                                                        if(data){
                                                            //console.log(data);
                                                            dispatch(close());
                                                            dispatch(
                                                                open({
                                                                    component: `특이사항 저장되었습니다.`,
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        rowDataSubmit();
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            );   
                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                        console.log(response);
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });                                                       
                                                }}
                                            />
                                        </div>                                              
                                    </div> }

                                    <div>
                                        {mettingsArr?.length > 0 &&
                                            <>
                                                <div className="title_txt bolds">미팅 기록</div>
                                                <div className='meetinglist'>
                                                    {mettingsArr?.length > 0 && mettingsArr?.map((x, i) => {
                                                        return (
                                                            <div key={i}>
                                                                <div>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                        <path d="M7.50033 1.3335V3.00016H12.5003V1.3335H14.167V3.00016H17.5003C17.9606 3.00016 18.3337 3.37326 18.3337 3.8335V17.1668C18.3337 17.6271 17.9606 18.0002 17.5003 18.0002H2.50033C2.04009 18.0002 1.66699 17.6271 1.66699 17.1668V3.8335C1.66699 3.37326 2.04009 3.00016 2.50033 3.00016H5.83366V1.3335H7.50033ZM16.667 8.8335H3.33366V16.3335H16.667V8.8335ZM12.5299 9.78016L13.7084 10.9587L9.58366 15.0835L6.63738 12.1372L7.81589 10.9587L9.58366 12.7265L12.5299 9.78016ZM5.83366 4.66683H3.33366V7.16683H16.667V4.66683H14.167V5.50016H12.5003V4.66683H7.50033V5.50016H5.83366V4.66683Z" fill="#999999" />
                                                                    </svg>
                                                                    {moment(x?.create_dt).format('MM.DD')}({yoil[moment(x?.create_dt).day()]})
                                                                </div>
                                                                <div style={{ whiteSpace: 'pre-wrap' }}>{x?.comment}</div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        }
                                        <div className='infos'>
                                            <div>
                                                <div>미팅횟수</div>
                                                <div>{mettingsArr?.length > 0 ? mettingsArr?.length : 0}회</div>
                                            </div>
                                            <div>
                                                <div>전송매물</div>
                                                <div>{customsendlist?.length > 0 ? customsendlist?.length : 0}건</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="title_txt bolds">전송매물</div>
                                        <div>
                                            {customsendlist?.length > 0 && customsendlist?.map((x, i) => {
                                                return (
                                                    <div className="productsendlistArea" key={i}>
                                                        <div>
                                                            <div className='linedotTxt'>
                                                                <span>{moment(x?.update_dt).format('YY.MM.DD')}</span>
                                                                <span></span>
                                                                <span>
                                                                    {x?.delete_dt !== null ?
                                                                        <><span className='colorF00'>관심없음</span></>
                                                                        :
                                                                        <><span className='bolds color6164A5'>{numFormat(x?.view)}</span>회열람</>
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div className='bolds'>
                                                                {row?.sell_type === '월세' ?
                                                                    <>
                                                                        월세 {numFormat(x?.item?.price_all)}/{numFormat(x?.item?.price_month)}
                                                                        /{((x?.item?.area_contract * 1) / 3.3057).toFixed(2)}평
                                                                    </>
                                                                    :
                                                                    <>{numFormat(x?.item?.price_sell)}만원 {((x?.item?.area_supply * 1) / 3.3057).toFixed(2)}평</>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <Button
                                                                onPress={() => {
                                                                    const PopComponents3 = () => {
                                                                        return (
                                                                            <div style={{ textAlign: 'left', width: '100%' }}>
                                                                                {x?.memo === null ? '내용이 없습니다' : x?.memo}
                                                                            </div>
                                                                        );
                                                                    }
                                                                    dispatch(
                                                                        open({
                                                                            component: <PopComponents3 />,
                                                                            title: '고객 평가',
                                                                            button: "취소",
                                                                            buttonCencle: "삭제하기",
                                                                            titleviewer: true,
                                                                            alert: false,
                                                                        })
                                                                    );
                                                                }}
                                                                buttonTxt={'고객\n평가'}
                                                                styles={{
                                                                    whiteSpace: 'pre-wrap', width: 56, height: 56
                                                                }}
                                                            />
                                                            <Button
                                                                buttonTxt={'매물\n상세'}
                                                                className={'linenormalbutton'}
                                                                onPress={() => {
                                                                    //detailViewer(x?.item)
                                                                    // setproductIdx(x?.item?.idx);
                                                                    // setproductdetailflag(true);
                                                                    navigate("/Product", {state: { itemIdx: x?.item?.idx }});           
                                                                }}
                                                                styles={{
                                                                    whiteSpace: 'pre-wrap', width: 56, height: 56
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>                                    
                                </div>

                            </div>
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )    
}